/**
 * Plaza Barn — small open-sided structure used as a campground gathering
 * point. There are six of these in Outeroo, each procedurally tinted.
 */

import * as THREE from 'three';

export interface PlazaBarnOptions {
  accentColor: string;
  podNumber: number;
}

export class PlazaBarn {
  static build(opts: PlazaBarnOptions): THREE.Group {
    const group = new THREE.Group();
    group.name = `PlazaBarn-${opts.podNumber}`;

    const matWood = new THREE.MeshStandardMaterial({
      color: '#5a3a20',
      roughness: 0.85
    });
    const matRoof = new THREE.MeshStandardMaterial({
      color: opts.accentColor,
      roughness: 0.6
    });
    const matSign = new THREE.MeshStandardMaterial({
      color: '#f5f0e8',
      roughness: 0.7
    });

    const w = 8;
    const d = 6;
    const wallH = 3.2;

    // Open wooden frame
    for (const sx of [-1, 1] as const) {
      for (const sz of [-1, 1] as const) {
        const post = new THREE.Mesh(
          new THREE.BoxGeometry(0.25, wallH, 0.25),
          matWood
        );
        post.position.set(sx * w / 2, wallH / 2, sz * d / 2);
        post.castShadow = true;
        group.add(post);
      }
    }
    // Beams
    for (const sz of [-1, 1] as const) {
      const beam = new THREE.Mesh(
        new THREE.BoxGeometry(w + 0.4, 0.3, 0.3),
        matWood
      );
      beam.position.set(0, wallH, sz * d / 2);
      group.add(beam);
    }

    // Pitched roof — two triangular planes
    for (const sign of [-1, 1] as const) {
      const roofPlane = new THREE.Mesh(
        new THREE.BoxGeometry(w + 1.4, 0.3, d * 0.6),
        matRoof
      );
      roofPlane.position.set(0, wallH + 0.6, sign * d * 0.18);
      roofPlane.rotation.x = sign * 0.5;
      roofPlane.castShadow = true;
      group.add(roofPlane);
    }

    // Sign
    const sign = new THREE.Mesh(
      new THREE.BoxGeometry(2.2, 0.6, 0.1),
      matSign
    );
    sign.position.set(0, wallH + 1.4, d / 2 + 0.1);
    group.add(sign);

    return group;
  }
}
